<template>
  <PopoverAvatar
    :user-id="userId"
    :organization-id="organizationId"
  >
    <ReportTableAvatarPlain
      :user-id="userId"
      :url="url"
      :avatar-style="avatarStyle"
    />
  </PopoverAvatar>
</template>

<script>
import ReportTableAvatarPlain from '~/components/reports/ReportTableAvatarPlain.vue';
import PopoverAvatar from '~/components/PopoverAvatar.vue';

export default {
  name: 'ReportTableAvatar',
  components: { PopoverAvatar, ReportTableAvatarPlain },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      default: undefined,
      required: false,
    },
    avatarStyle: {
      type: String,
      default: 'speck',
    },
  },
  computed: {
    organizationId() {
      // Avoid trying to access the store when tables are reloading
      return this.$store?.state?.organization_id || null;
    },
  },
};
</script>
